module.exports = __webpack_public_path__ + "assets/images/electoral-college/icons/election-day.svg?v=837e52d3";